<template>
    <div class="legend-container">
        <div
                v-for="(color, index) in colors"
                :key="index"
                class="legend-item"
        >
          <span class="legend-item-color-block" :style="{ backgroundColor: color.hex }" ></span>
          <span class="legend-item-size">{{ color.size }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MapLegend',
    props: {
        colors: {
            type: Array,
            required: true
        }
    }
}
</script>

<style scoped>

.legend-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: stretch;
  -ms-flex-pack: stretch;
  justify-content: stretch;
  -ms-flex-flow: wrap;
  flex-flow: wrap;
}
.legend-item-color-block {
  width: 15px;
  height: 15px;
  display: inline-block;
  border-radius: 4px;
}
.legend-item-size {
  display: inline-block;
  font-weight: bold;
  margin:0 5px;
  white-space: nowrap;
}

</style>
